import React from 'react'

import AddRoleForm from '../../modules/Role/components/AddRoleForm'
export default function AddRolePage() {
  return <AddRoleForm />
}
